
import { Route, Routes, Navigate } from "react-router-dom";
import { ErrorPageView } from "./ErrorPageView";

export default function ErrorsPage() {
  return (
    <Routes>
      <Route path="/error" element={<Navigate  to="/error/error-v6" />} />
      <Route path="/error/error-v6" element={<ErrorPageView />} />
    </Routes>
  );
}
